import React from 'react';

export const getDateRangeFromTile = async (map, sourceId = 'martin.geo_starts_mvt') => {
    try {
        const source = map.getSource(sourceId);
        if (!source) {
            return null;
        }
        const metadataLayerId = `__metadata_query_layer_${sourceId}`;
        const layerExists = map.getLayer(metadataLayerId);
        if (!layerExists) {
            try {
                map.addLayer({
                    id: metadataLayerId,
                    type: 'fill',
                    source: sourceId,
                    'source-layer': 'metadata',
                    paint: {
                        'fill-opacity': 0,
                    },
                });
            } catch (err) {
                console.warn('[DateRange] Could not create metadata layer:', err.message);
            }
        }
        try {
            const rendered = map.queryRenderedFeatures({ layers: [ metadataLayerId ] });
            if (rendered && rendered.length > 0) {
                const props = rendered[0].properties;
                return {
                    minDate: props.min_date,
                    maxDate: props.max_date,
                };
            }
        } catch (err) {
            console.warn('[DateRange] queryRenderedFeatures error:', err.message);
        }
        return null;
    } catch (error) {
        console.error('[DateRange] Error fetching date range from tile:', error);
        return null;
    }
};

/**
 * Убирает служебный fill-слой, который getDateRangeFromTile создаёт, чтобы форсировать
 * загрузку тайлов source-layer 'metadata'. Слой не скрывается через visibility:'none',
 * поэтому источник считается mapbox-gl "used" и продолжает грузить тайлы на каждый пан/зум
 * пока слой существует — вызывать сразу как метаданные больше не нужны (выключили слой карты).
 */
export const removeMetadataQueryLayer = (map, sourceId = 'martin.geo_starts_mvt') => {
    const metadataLayerId = `__metadata_query_layer_${sourceId}`;
    if (map.getLayer(metadataLayerId)) {
        map.removeLayer(metadataLayerId);
    }
};

/**
 * Хук для получения диапазона дат при загрузке карты
 * @param {Object} map - Mapbox GL JS map instance
 * @param {string} sourceId - ID источника
 * @returns {Promise<Object|null>} Диапазон дат
 */
export const useDateRangeFromTile = (map, sourceId = 'martin.geo_starts_mvt') => {
    React.useEffect(() => {
        if (!map) return;

        const onDataLoaded = async () => {
            const dateRange = await getDateRangeFromTile(map, sourceId);
            if (dateRange) {
                // Successfully loaded dateRange
            }
        };

        // Слушаем событие когда тайлы полностью загружены
        map.on('sourcedata', onDataLoaded);

        return () => {
            map.off('sourcedata', onDataLoaded);
        };
    }, [ map, sourceId ]);
};
